const SITUATIONS = [
  {
    icon: 'ri-group-line',
    title: 'Семейные ужины на воздухе',
    desc: 'Просторная беседка вмещает всю семью. Ужин на&nbsp;свежем воздухе без комаров и&nbsp;дождя — теперь хоть&nbsp;каждый&nbsp;вечер.',
  },
  {
    icon: 'ri-cake-line',
    title: 'Гости на выходных',
    desc: 'Друзья и родственники в гостях — всем хватит места. Беседка становится центром притяжения на&nbsp;участке.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Нужна летняя кухня',
    desc: 'С мангальной зоной или хозблоком беседка превращается в&nbsp;полноценную летнюю кухню. Готовьте и&nbsp;отдыхайте в&nbsp;одном&nbsp;месте.',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Тихое место для отдыха',
    desc: 'Закрытая беседка с мягкими окнами — ваш личный уголок. Читайте, работайте или просто наслаждайтесь тишиной в&nbsp;любую&nbsp;погоду.',
  },
];

export default function UseCasesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Подойдёт, если вам нужно
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Четыре жизненные ситуации, в которых беседка решает задачу с&nbsp;комфортным&nbsp;отдыхом на&nbsp;участке
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {SITUATIONS.map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 transition-all duration-400 hover:border-primary-200/50 animate-fade-in-up"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-400">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}